import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_7 = { class: "p-grid" }
const _hoisted_8 = { class: "p-col-4" }
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = { class: "p-col" }
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_22 = { class: "p-col" }
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_25 = { class: "p-grid" }
const _hoisted_26 = { class: "p-col" }
const _hoisted_27 = { class: "p-field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "brandName" }, "Brands", -1)
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "sectorName" }, "Brand Sectors", -1)
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = { class: "p-field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "categoryName" }, "Category", -1)
const _hoisted_35 = { class: "p-col" }
const _hoisted_36 = { class: "p-field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "productType" }, "Product Type", -1)
const _hoisted_38 = { class: "p-field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Batch No", -1)
const _hoisted_40 = { class: "p-grid" }
const _hoisted_41 = { class: "p-col" }
const _hoisted_42 = { class: "p-field" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Report", -1)
const _hoisted_44 = { class: "p-col" }
const _hoisted_45 = { class: "p-field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)
const _hoisted_47 = { class: "p-grid" }
const _hoisted_48 = { class: "p-col" }
const _hoisted_49 = { class: "p-field" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Customer", -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_52 = { class: "pull-right" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_54 = { class: "pull-right" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_56 = { class: "pull-right" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_58 = { class: "pull-right" }
const _hoisted_59 = { class: "p-col" }
const _hoisted_60 = { class: "p-field" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "User", -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_63 = { class: "pull-right" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_65 = { class: "pull-right" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_67 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.searchFilters.type) + " Tax Report", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          value: _ctx.taxReport,
          lazy: true,
          scrollable: true,
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Store Name",
              style: {"width":"170rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.branchName) + " (" + _toDisplayString(slotProps.data.branchCode) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Date" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receiptDate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "receiptNo",
              header: "Receipt No"
            }),
            _createVNode(_component_Column, {
              header: "Customer Name",
              style: {"width":"170rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.customerName) + " (" + _toDisplayString(slotProps.data.customerContact) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "User Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.userName) + " (" + _toDisplayString(slotProps.data.userContact) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Item Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.itemName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Qty" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.unit) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Total Units" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.totalUnit) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Batch No" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.batchNo), 1)
              ]),
              _: 1
            }),
            (_ctx.searchFilters.type == 'Sales' || _ctx.searchFilters.type == 'Refund' || _ctx.searchFilters.type == 'Transfer')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  header: "Selling Price"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.sellingPrice)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.searchFilters.type == 'Purchase' || _ctx.searchFilters.type == 'Purchase Return')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 1,
                  header: "Purchase Price"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.purchasePrice)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.searchFilters.type == 'Sales' || _ctx.searchFilters.type == 'Refund' || _ctx.searchFilters.type == 'Transfer')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 2,
                  header: "Disc"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.itemDisc)) + " % ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.searchFilters.type == 'Purchase' || _ctx.searchFilters.type == 'Purchase Return')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 3,
                  header: "Purchase Disc"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.purchaseDisc)) + " % ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.taxNames[0].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 4,
                  header: _ctx.taxNames[0].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax1)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[0].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 5,
                  header: _ctx.taxNames[0].taxName + '(Amount)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.taxNumber1)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 6,
                  header: _ctx.taxNames[1].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax2)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 7,
                  header: _ctx.taxNames[1].taxName + '(Amount)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.taxNumber2)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 8,
                  header: _ctx.taxNames[2].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax3)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 9,
                  header: _ctx.taxNames[2].taxName + '(Amount)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.taxNumber3)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Column, { header: "Subtotal" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.subTotal)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tr", null, [
              (_ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_10, "Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax1Amt)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, "Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax2Amt)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createElementBlock("td", _hoisted_12, "Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax3Amt)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_13, [
            _hoisted_14,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Dropdown, {
                  id: "brandName",
                  modelValue: _ctx.searchFilters.brandName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.brandName) = $event)),
                  options: _ctx.brands,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_Dropdown, {
                  id: "sectorName",
                  modelValue: _ctx.searchFilters.sectorName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.sectorName) = $event)),
                  options: _ctx.sectors,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_component_Dropdown, {
                  id: "categoryName",
                  modelValue: _ctx.searchFilters.categoryName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.categoryName) = $event)),
                  options: _ctx.categories,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_Dropdown, {
                  id: "productType",
                  modelValue: _ctx.searchFilters.productType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.productType) = $event)),
                  options: _ctx.productTypes,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_InputText, {
              modelValue: _ctx.searchFilters.batchNo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.batchNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode(_component_Dropdown, {
                  id: "type",
                  modelValue: _ctx.searchFilters.type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFilters.type) = $event)),
                  options: _ctx.reportTypes,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.searchFilters.customerName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchFilters.customerName) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_51,
                      _createElementVNode("b", _hoisted_52, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_53,
                      _createElementVNode("span", _hoisted_54, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_55,
                      _createElementVNode("span", _hoisted_56, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_57,
                      _createElementVNode("span", _hoisted_58, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveUser($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.searchFilters.UserName,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchFilters.UserName) = $event)),
                  suggestions: _ctx.userList,
                  placeholder: "Search User",
                  onComplete: _cache[15] || (_cache[15] = ($event: any) => (_ctx.searchUser($event))),
                  dropdown: false
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_62,
                      _createElementVNode("b", _hoisted_63, _toDisplayString(slotProps.item.name.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_64,
                      _createElementVNode("span", _hoisted_65, _toDisplayString(slotProps.item.email), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_66,
                      _createElementVNode("span", _hoisted_67, _toDisplayString(slotProps.item.contact), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}